import { Post } from "./config";

// const API_VER = process.env.REACT_APP_API_VER;

export const attemptLogin = (params) => Post( 'login', params);
